import { x } from '@xstyled/styled-components';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { t } from 'ttag';
import { Button } from '~/ui/buttons';
import { Flex } from '~/ui/flex/Flex';
import { LlamaModal } from '~/ui/llama-modal/LlamaModal';
import { Logo } from '~/ui/logo/Logo';
import { select } from '~/lib/select';
import { useTrainingUrl } from '../useTrainingUrl';
import styled from 'styled-components';
import PointOfContact from '~/ui/point-of-contact/PointOfContact';
import { TrainingState, useTrainingStore } from '~/training/state';
import { Sequence } from '~/training/state/navigation/NavigationSlice';

const PassFailDiv = styled.div`
  display: contents;
  @media only screen and (max-width: 768px) {
    .LlamaModalOverlay {
      justify-content: start !important;
      align-items: center !important;
    }

    .LlamaModalWrapper {
      padding-top: 0px;
    }
  }

  .success-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 100%;

    h2 {
      color: dark;
      font-family: Recoleta;
      font-size: 36px;
      font-style: normal;
      font-weight: 400;
      line-height: 120%;
      text-transform: capitalize;
      margin-bottom: 20px;
    }

    @media only screen and (max-width: 768px) {
      flex-direction: column;
    }

    .left-side {
      width: 55%;
      height: 100%;
      padding-right: 40px;
      text-align: left;
      padding-left: 10px;

      @media only screen and (max-width: 768px) {
        width: 100% !important;
        padding-right: 0px !important;
        padding-left: 0px !important;
        margin-bottom: 20px;
      }

      .linkSection {
        p {
          padding-bottom: 20px;
        }

        button {
          text-align: left;
          padding: 12px;
          font-size: 14px;
          margin-bottom: 10px;
          width: 97%;
          padding-top: 14px;
          padding-bottom: 14px;
          font-family: ralewayBold;
          text-align: center;
          max-width: 250px;
        }

        a {
          margin-bottom: 10px;
          margin-right: 10px;
          padding: 10px 30px;
          font-size: 14px;
          padding-left: 50px !important;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: 700;
          font-family: ralewayBold;
          text-align: center;
          max-width: 250px;
        }

        .notPrimary {
          opacity: 0.7;
        }

        @media only screen and (max-width: 768px) {
          max-width: 100%;

          a {
            max-width: 100% !important;
            margin-right: 0px !important;
          }

          button {
            max-width: 100% !important;
            margin-right: 0px !important;
          }
        }
      }
    }

    .oneColumn {
      .linkSection {
        a {
          margin-left: auto !important;
          margin-right: auto !important;
        }

        button {
          margin-left: auto !important;
          margin-right: auto !important;
        }
      }
    }

    .right-side {
      width: 45%;
      height: 100%;
      padding-left: 20px;
      text-align: left;
      padding-right: 10px;

      @media only screen and (max-width: 768px) {
        width: 100%;
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
`;

const selector = (s: TrainingState) =>
  select(
    s,
    'logoUrl',
    'scorePercent',
    'companyContacts',
    'scorePassingPercent',
    'items'
  );

export const PassFail = () => {
  const { logoUrl, scorePercent, scorePassingPercent, companyContacts, items } =
    useTrainingStore(selector);

  const history = useHistory();
  const trainingUrl = useTrainingUrl();

  const getFirstSequenceInFirstChapter = (): Sequence | null => {
    if (!items || items.length === 0) return null;

    const firstChapter = items.find(item => item.kind === 'chapter');
    if (!firstChapter) return null;

    const firstSequence = items.find(
      item => item.kind === 'sequence' && item.chapterId === firstChapter.id
    ) as Sequence | undefined;

    return firstSequence || null;
  };

  const retakeCourse = () => {
    const firstSequence = getFirstSequenceInFirstChapter();

    if (firstSequence && trainingUrl) {
      history.push(`${trainingUrl}/${firstSequence.id}`);
    } else if (trainingUrl) {
      history.push(trainingUrl);
    }
  };

  return (
    <PassFailDiv className="PassFailDiv">
      <x.div w="100%" h="100%" bg={'var(--color-accent-lt)'} />
      <LlamaModal showLlama="hide">
        <Flex variant="list" p="lg" gap="md" maxW="800px" textAlign="center">
          <div className="success-container">
            <div
              className={`left-side ${
                !companyContacts || companyContacts.length === 0
                  ? 'oneColumn'
                  : ''
              }`}
              style={{
                width:
                  companyContacts && companyContacts.length > 0
                    ? '55%'
                    : '100%',
                paddingRight:
                  companyContacts && companyContacts.length > 0 ? '40px' : '0px'
              }}
            >
              <div>
                <Logo
                  src={logoUrl}
                  height="36"
                  style={{
                    margin: 'unset',
                    marginBottom: '20px',
                    color: 'dark'
                  }}
                />
              </div>
              <x.h2 fontFamily="llama">{t`You're almost there!!`}</x.h2>
              <div className="linkSection">
                <>
                  <p>
                    {t`You scored ${scorePercent}%, but you need ${scorePassingPercent}% or higher to complete this course.`}
                    <br />
                    {t`Don't worry — you can try again when you're ready.`}
                  </p>
                  <Button
                    key="finish_btn"
                    onClick={retakeCourse}
                  >{t`Retake Course`}</Button>
                </>
              </div>
            </div>
            {companyContacts && companyContacts.length > 0 && (
              <div className="right-side">
                <PointOfContact title={t`Here are your points of contact`} />
              </div>
            )}
          </div>
        </Flex>
      </LlamaModal>
    </PassFailDiv>
  );
};
